module.exports = __webpack_public_path__ + "static/14-ad2cda7938f0bae93a98a1b72ddc7f6b.png";